// eslint-disable-next-line max-len
export const API_MY_PROBATIX_ENTRYPOINT: string = process.env.VITE_CORE_API_ENTRYPOINT ? (`${process.env.VITE_CORE_API_ENTRYPOINT}/api`) : 'http://probatix.localhost:8000/api'
export const EXPIRY_OF_STORAGE_MINUTES: string = process.env.VITE_EXPIRY_OF_STORAGE_MINUTES || '5'
export const COOKIE_POLICY_KEY: string = 'COOKIE_POLICY_KEY'
export const EXPIRY_OF_JWT_TOKEN_MINUTES: string = '59'
